'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcCalendar = require('rc-calendar');

var _rcCalendar2 = _interopRequireDefault(_rcCalendar);

var _Picker = require('rc-calendar/lib/Picker');

var _Picker2 = _interopRequireDefault(_Picker);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinaryDatePicker = function (_Component) {
  _inherits(BinaryDatePicker, _Component);

  function BinaryDatePicker(props) {
    _classCallCheck(this, BinaryDatePicker);

    var _this = _possibleConstructorReturn(this, (BinaryDatePicker.__proto__ || Object.getPrototypeOf(BinaryDatePicker)).call(this, props));

    _this.styles = require('./BinaryDatePicker.scss');
    return _this;
  }

  _createClass(BinaryDatePicker, [{
    key: 'onChange',
    value: function onChange(value) {
      var onChange = this.props.onChange;

      onChange(value.format('YYYY-MM-DD HH:mm:ss'));
    }
  }, {
    key: 'getFormat',
    value: function getFormat(time) {
      var format = this.props.format;

      return time ? format : 'YYYY-MM-DD HH:mm:ss';
    }
  }, {
    key: 'disabledDate',
    value: function disabledDate(current) {
      if (!current) {
        return false;
      }
      var date = (0, _moment2.default)();
      date.hour(0);
      date.minute(0);
      date.second(0);
      return current < date; // can not select days before today
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          selectedDate = _props.selectedDate,
          disablePrevious = _props.disablePrevious;


      var calendar = _react2.default.createElement(_rcCalendar2.default, {
        style: { zIndex: 99999 },
        formatter: this.getFormat.bind(this, true),
        defaultValue: selectedDate !== '' ? selectedDate : (0, _moment2.default)().toDate(),
        showOk: false,
        disabledDate: disablePrevious ? this.disabledDate.bind(this) : ''
      });

      return _react2.default.createElement(
        'div',
        { style: { width: 400, margin: 20 } },
        _react2.default.createElement(
          'div',
          { style: {
              boxSizing: 'border-box',
              position: 'relative',
              display: 'block',
              lineHeight: 1.5,
              marginBottom: 22
            }
          },
          _react2.default.createElement(
            _Picker2.default,
            {
              animation: 'slide-up',
              disabled: false,
              style: { zIndex: 9999 },
              calendar: calendar,
              value: selectedDate !== '' ? selectedDate : (0, _moment2.default)().toDate(),
              onChange: this.onChange.bind(this)
            },
            function (_ref) {
              var value = _ref.value;

              return _react2.default.createElement(
                'span',
                { tabIndex: '0' },
                _react2.default.createElement('input', {
                  placeholder: 'please select',
                  style: { width: 180 },
                  disabled: false,
                  readOnly: true,
                  tabIndex: '-1',
                  className: 'ant-calendar-picker-input ant-input',
                  value: value && value.format('YYYY-MM-DD') || ''
                })
              );
            }
          )
        )
      );
    }
  }]);

  return BinaryDatePicker;
}(_react.Component);

BinaryDatePicker.propTypes = {
  onChange: _propTypes2.default.func,
  selectedDate: _propTypes2.default.object,
  format: _propTypes2.default.string,
  disablePrevious: _propTypes2.default.bool
};
BinaryDatePicker.defaultProps = {
  format: 'YYYY-MM-DD HH:mm:ss'
};
exports.default = BinaryDatePicker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryDatePicker/BinaryDatePicker.js
// module id = 1080
// module chunks = 1